import { EXPORT_STATUS } from 'dynamo-daos/build/models/jobs/exportRecord';

import apiRequest from './apiRequest';

type ApiResponse = {
  downloadURL: string;
  estimatedFinishTime: string;
  exportID: string;
  projectID: string;
  retriesRemaining: number;
  startedAt: string;
  status: EXPORT_STATUS;
};

export default async function getProjectExport(
  projectID: string,
  exportID: string = 'latest',
) {
  return await apiRequest<ApiResponse>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/export/${exportID}`,
  );
}
